import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { AnimatedPageLoader } from 'smartsuite-ui';
import InitialState from './InitialState';
import ExternalState from './ExternalState';
import SearchApp from './SearchApp';
import { LabelContextProvider } from '../shared/hooks/labelContext';
import { createCanvas } from '../viewDashboards/export/exportUtils';

export default function AppWrapper(props) {
    useEffect(() => {
        createCanvas();
    }, []);

    function renderSearchApp(
        {
            deleteSavedSearch,
            loadedSavedSearch,
            loadSavedSearch,
            isLoaded,
            savedSearchError,
            savedSearchNames,
            saveSearch,
        },
        selectOptions
    ) {
        if (!isLoaded) {
            return <AnimatedPageLoader />;
        }
        return (
            <SearchApp
                configuration={loadedSavedSearch}
                deleteSavedSearch={deleteSavedSearch}
                savedSearchError={savedSearchError}
                savedSearchNames={savedSearchNames}
                saveSearch={saveSearch}
                loadSavedSearch={loadSavedSearch}
                selectOptions={selectOptions}
                uriConstants={props.uriConstants}
            />
        );
    }

    return (
        <LabelContextProvider siteLanguage={props.siteLanguage}>
            <InitialState
                uriConstants={props.uriConstants}
                render={({
                    initialConfiguration,
                    initialStateLoaded,
                    selectOptions,
                }) => (
                    <ExternalState
                        initialConfiguration={initialConfiguration}
                        initialStateLoaded={initialStateLoaded}
                        selectOptions={selectOptions}
                        uriConstants={props.uriConstants}
                        render={(externalStateProps) =>
                            renderSearchApp(externalStateProps, selectOptions)
                        }
                    />
                )}
            />
        </LabelContextProvider>
    );
}

AppWrapper.propTypes = {
    siteLanguage: PropTypes.string,
    uriConstants: PropTypes.instanceOf(Object).isRequired,
};

AppWrapper.defaultProps = {
    siteLanguage: 'en',
};
